import React, { PureComponent } from 'react';
import Item from './Item';


class List extends PureComponent {

  render() {
    const { title, values } = this.props;
    return (
      <div className="list">
        <h4 className="list__title">{title}</h4>
        <div className="row">
          {
            values.map((obj, index) => {
              return (
                <div key={index} className="col-lg-3 col-md-6 col-xs-12">
                  <Item {...obj}/>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}

List.propTypes = {};
List.defaultProps = {};

export default List;



// WEBPACK FOOTER //
// ./src/components/List/List.js